import React, { Component } from "react";
import PropTypes from "prop-types";
import { Icon } from "MODULES/shared/components";
import { ATTACHMENT_TYPES } from "MODULES/inventories/constants";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import AttachmentType from "./AttachmentType";

export default class EditAttachment extends Component {
  static propTypes = {
    id: PropTypes.number.isRequired,
    resourceType: PropTypes.string.isRequired,
    attachmentType: PropTypes.string
  };

  state = {
    open: false
  };

  close = () => this.setState({ open: false });

  openModal = () => this.setState({ open: true });

  render() {
    const { attachmentType, id, resourceType, attachmentTypes } = this.props;
    const { open } = this.state;
    const initialValues = {
      attachment_type: attachmentType
    };

    const attachmentTypeOptions =
      resourceType === "companies" ? attachmentTypes : ATTACHMENT_TYPES;
    return (
      <div>
        <button className="btn-link" onClick={this.openModal}>
          <Icon name="pencil" fixed />
          Edit Attachment Type
          <Modal open={open} close={this.close} dialogClass="modal-sm">
            <Header>
              <Close close={this.close} />
              <h4 className="modal-title">Edit Attachment Type</h4>
            </Header>
            <AttachmentType
              id={id}
              close={this.close}
              resourceType={resourceType}
              attachmentTypes={attachmentTypeOptions}
              initialValues={initialValues}
            />
          </Modal>
        </button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/modules/shared/components/Attachments/EditAttachment.jsx